/* eslint-disable camelcase */
import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import queryString from 'query-string';
import isEqual from 'lodash/isEqual';
import cn from 'classnames';

import { analyticService } from 'global/services';

import { ADDITIONAL_DISHES_CATEGORIES, CATEGORY_SOUPS } from 'app/const/categories';
import { MenuDispatchContext } from 'app/containers/contexts/menu.context';

import Responsive from 'app/components/Responsive';
import DishDAC from 'app/views/Menu/Menu/DAC/DishDAC';
import { MenuSelectionsMobileSlider } from 'app/components/banners/MenuSelectionsMobileSlider/MenuSelections';
import { useProductImpressionObserver } from 'global/hooks/useProductImpressionObserver';

import './dishes.scss';
import {
    abTestDataContext, MENU_SORT_DATES, MENU_SORT_DATES_CONTROL, MENU_SORT_DATES_TEST,
} from 'app/containers/contexts/abTest.context';
import { menuImageSize } from 'app/utils/dish';
import { menu } from 'app/assets/dishesSelections/dishesSelections';
import { useCartMutationInBasket } from 'app/views/Basket/hooks';
import { NYLPBanner } from '../banners/NYLPBanner/NYLPBanner';
import { PromoMaxiBlock } from '../PromoMaxiBlock/PromoMaxiBlock';
import { SpecialBanners } from '../SpecialBanners/SpecialBanners';


const isShelfLifeDisplayed = (categoryId) => ADDITIONAL_DISHES_CATEGORIES.includes(categoryId);

const isLazyLoadingEnabled = (isCategoryActive, index, useLazyLoading) => {
    if (!isCategoryActive) {
        return useLazyLoading;
    }

    if (index === 0) {
        return false;
    }

    return useLazyLoading;
};


class Dishes extends React.Component {
    constructor(props) {
        super(props);
        this.listRef = React.createRef();
    }

    // eslint-disable-next-line react/sort-comp, class-methods-use-this, consistent-return
    trackDishDetailsViewed = (dishId) => {
        const {
            categoryTitle,
            menuDishesQuery: { menuDishes },
            categoryId,
            subscriptionType,
        } = this.props;

        const dish = menuDishes.find(({ id }) => Number(id) === Number(dishId));

        if (!dish) return null;

        const {
            id,
            title,
            caption,
            price,
        } = dish;

        analyticService.push({
            id,
            title,
            caption,
            price,
            category: categoryTitle,
            categoryId,
            source: 'menu',
            eventName: 'Dish_Details_Viewed',
            subscriptionType,
        }).push({
            id,
            eventName: 'CityAds_Dish_Details_Viewed',
        });
    };

    dispatchOnCardClickAnalytic = (dish) => {
        const { subscriptionType } = this.props;
        analyticService.push({
            eventName: 'Track_Card_Click', ...dish, list: 'all', subscriptionType,
        });
    };

    render() {
        const {
            spaDishObserver,
            isCategoryActive,
            menuDishesQuery,
            useLazyLoading,
            isBasketLoading,
            isDishesUpdating,
            categoryId,
            // dishIndexForRenderSlider,
            isDishesSliderNeeded,
            dishComponentType,
            place,
            updateLastDish,
            thirdDishId,
            fifthDishId,
            sixthDishId,
            seventhDishId,
            ninthDishId,
            abTestDataContext,
            handleAddPairOfDishesToBasket,
            ...dishesProps
        } = this.props;

        const { menuDishes } = menuDishesQuery;

        const isSelectionDish = categoryId === 'selection' && dishComponentType === 'mobile';

        const dishesListRoot = cn({
            'dishes-list': true,
            [categoryId]: true,
        });

        return (
            <ul styleName={dishesListRoot} ref={this.listRef}>
                {menuDishes.map((dish, i, arr) => {
                    const arrTail = arr.length - 1;
                    const useLazyLoadingProp = isLazyLoadingEnabled(isCategoryActive, i, useLazyLoading);

                    if (dish.id === '4847') {
                        return null;
                    }

                    const commonProps = {
                        arrTail,
                        index: i,
                        isShelfLife: isShelfLifeDisplayed(categoryId),
                        parentRef: this.listRef,
                        useLazyLoading: useLazyLoadingProp,
                        canApplySoldOutStyles: true,
                        onOpenDetails: this.trackDishDetailsViewed,
                        dispatchOnCardClickAnalytic: this.dispatchOnCardClickAnalytic,
                        spaDishObserver,
                        ...dishesProps,
                        categoryId,
                        onClickAddPairToBasket: handleAddPairOfDishesToBasket,
                    };

                    const num_cID = categoryId === 'intresting' ? '0' : String(categoryId);

                    const cID = categoryId === 'intresting' ? `${dish.id}:0` : `${dish.id}:${categoryId}`;

                    const sliderContainerClasses = cn({
                        'dishes-list__slider-container': true,
                        'is-hidden': isDishesUpdating,
                    });

                    const onClick = (data) => {
                        const { onClickAddToBasket } = dishesProps;
                        const { updatePromoCompoentPosition } = this.props;
                        onClickAddToBasket(data);
                        updatePromoCompoentPosition(data.rootDishID, num_cID);
                    };

                    const queryParams = queryString.parse(window.location.search);
                    const maxiBlockType = queryParams?.maxi_block_type;

                    return (
                        <React.Fragment key={dish.id}>
                            <Responsive
                                mobile={(
                                    <>
                                        <DishDAC
                                            id={dish.id}
                                            cardProps={{
                                                ...commonProps,
                                                disabled: isBasketLoading,
                                                isDishUpdating: isDishesUpdating,
                                                onClickAddToBasket: onClick,
                                            }}
                                            cardLayout="mobile"
                                        />
                                        {(cID === thirdDishId) && (
                                            <div style={{ width: '100%' }}>
                                                <div styleName={sliderContainerClasses}>
                                                    <MenuSelectionsMobileSlider realm="menu_realm" />
                                                </div>
                                            </div>
                                        )}
                                        {/* {(cID === thirdDishId) && isInBR1200ABTest && (
                                            <div id="specialsThird" style={{ width: '100%' }}>
                                                <SpecialBanners ids="ny.hp.guests" specialsAncor="specialsThird" />
                                            </div>
                                        )} */}
                                        {/* {(cID === sixthDishId) && isInBR1200ABTest && (
                                            <div id="specialsSixth" style={{ width: '100%' }}>
                                                <SpecialBanners ids="green.kids.speed" specialsAncor="specialsSixth" />
                                            </div>
                                        )} */}
                                        {(cID === ninthDishId) && (
                                            <PromoMaxiBlock
                                                contentKey={maxiBlockType || 'sauces'}
                                                selectionKey={maxiBlockType || 'sauces'}
                                                observer={spaDishObserver}
                                            />
                                        )}
                                    </>
                                )}
                                desktop={(
                                    <DishDAC
                                        id={dish.id}
                                        cardProps={dishComponentType === 'mobile'
                                            ? {
                                                disabled: isBasketLoading,
                                                isDishUpdating: isDishesUpdating,
                                                ...commonProps,
                                            }
                                            : commonProps}
                                        cardLayout={isSelectionDish ? 'selectionMobile' : 'desktop'}
                                    />
                                )}
                                key={dish.id}
                            />
                            {/* {isNYLPBannerShown && (
                                <div styleName="NYLPBannerWrapper">
                                    <NYLPBanner />
                                </div>
                            )} */}
                        </React.Fragment>
                    );
                })}
            </ul>
        );
    }
}

Dishes.propTypes = {
    isCategoryActive: PropTypes.bool,
    overlayIsOpen: PropTypes.bool,

    isDishesUpdating: PropTypes.bool.isRequired,
    useLazyLoading: PropTypes.bool,
    menuDispatchContext: PropTypes.func.isRequired,
    categoryTitle: PropTypes.string,
    isDishesSliderNeeded: PropTypes.bool.isRequired,

    spaDishObserver: PropTypes.shape({
        observe: PropTypes.func,
    }).isRequired,

    menuDishesQuery: PropTypes.shape({
        loading: PropTypes.bool,
        error: PropTypes.shape({}),
        menuDishes: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    categoryId: PropTypes.string.isRequired,
    isMobileMenuDishesVisible: PropTypes.bool.isRequired,

    dishComponentType: PropTypes.string,
    subscriptionType: PropTypes.string,
};
const checkDishesEqual = (prev, next) => {
    if (!prev) {
        return false;
    }
    return isEqual(new Set(prev), new Set(next));
    // return [...new Set([...prev, ...next])].length === 4;
};

const MenuSliderAdapter = ({
    isCategoryActive = false,
    overlayIsOpen = false,
    useLazyLoading = true,
    categoryTitle = '',
    dishComponentType = 'responsive',
    subscriptionType = '',
    menuDishesQuery,
    menuDishesQuery: { menuDishes },
    isDishesSliderNeeded,
    isDishesUpdating,
    location,
    flatDishesList = [],
    ...restProps
}) => {
    const menuDispatchContext = useContext(MenuDispatchContext);

    const abTestDataContextValue = useContext(abTestDataContext);

    const deliveryId = useMemo(
        () => window.location.pathname.split('/').find((e) => Boolean(e) && !Number.isNaN(Number(e))),
        [window.location.pathname],
    );

    const { mutateItemInCart } = useCartMutationInBasket({ delivery_Id: deliveryId });

    const handleSendAnalytics = (intersectingDish) => {
        const isBasket = location.pathname.includes('/basket');
        const params = queryString.parse(window.location.search);
        const isMaxi = params?.st && params?.st.includes('maxi');
        const nonSpecificValue = isBasket ? 'basket' : 'menu';
        const source = isMaxi ? 'maxi' : nonSpecificValue;
        const intersectingDishIndex = flatDishesList
            ?.findIndex((e) => e.id === intersectingDish[0]?.id);
        analyticService.push({
            eventName: 'Product_Impression',
            dish: intersectingDish,
            dishIndex: intersectingDishIndex > -1
                ? intersectingDishIndex + 1
                : null,
            source_name: params?.src ?? source,
        });
    };

    const [spaDishObserver] = useProductImpressionObserver({
        dishesArray: menuDishes,
        analyticsHandler: handleSendAnalytics,
    });

    const handleAddPairOfDishesToBasket = useCallback(
        ({ rootDish, additionalDish }) => {
            mutateItemInCart(
                {
                    dishes: [
                        { dish_id: rootDish.id, portions: rootDish.portion },
                        { dish_id: additionalDish.id, portions: additionalDish.portion },
                    ],
                },
            );
        },
        [mutateItemInCart],
    );

    return (
        <Dishes
            {...restProps}
            abTestDataContext={abTestDataContextValue}
            menuDispatchContext={menuDispatchContext}
            menuDishesQuery={menuDishesQuery}
            isDishesUpdating={isDishesUpdating}
            subscriptionType={subscriptionType}
            isDishesSliderNeeded={isDishesSliderNeeded}
            spaDishObserver={spaDishObserver}
            isCategoryActive={isCategoryActive}
            overlayIsOpen={overlayIsOpen}
            useLazyLoading={useLazyLoading}
            categoryTitle={categoryTitle}
            dishComponentType={dishComponentType}
            handleAddPairOfDishesToBasket={handleAddPairOfDishesToBasket}
        />
    );
};

MenuSliderAdapter.propTypes = {
    categoryId: PropTypes.string.isRequired,
    menuDishesQuery: PropTypes.shape({
        menuDishes: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    isDishesSliderNeeded: PropTypes.bool.isRequired,
    isDishesUpdating: PropTypes.bool.isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string.isRequired,
    }).isRequired,
    subscriptionType: PropTypes.string,
};


export default trackWindowScroll(MenuSliderAdapter);
